$(document).ready(function () {
	// Main nav active element
	$('.desktop-nav li').click(function () {
		$(this).addClass('active');
		$(this).parent().children('li').not(this).removeClass('active');
	});

	// Mobile nav toggle
	$('.menu-hamburger').click(function () {
		$(this).hide();
		$('.menu').show();
	});

	$('.menu-close').click(function () {
		$('.menu').hide();
		$('.menu-hamburger').show();
	});

	// Homepage redesign
	$('.tab-buttons li').on('click', function () {
		const tabId = $(this).data('tab');

		// přepne aktivní tlačítko
		$('.tab-buttons li').removeClass('active');
		$(this).addClass('active');

		// přepne aktivní obsah
		$('.tab-content .tab').removeClass('active');
		$(tabId).addClass('active');
	});

	$(function () {
		$('.bxslider').bxSlider({
			mode: 'fade',
			captions: true,
			slideWidth: 600,
		});
	});
});
